module.exports = __webpack_public_path__ + "img/category-dresses.21cff4ac.jpg";